import { ComponentType } from 'react';

import {
    AvailableSystemsProps,
    PaymentSystemName,
    PaymentSystemProps,
} from '../service/paymentSettings.interface';
import { UnitpayStepInit } from '../components/unitpay/ui/UnitpayStepInit';
import { UnitpayStepConnect } from '../components/unitpay/ui/UnitpayStepConnect';
import { YookassaStepConnect } from '../components/yookassa/ui/YookassaStepConnect';
import { YookassaStepInit } from '../components/yookassa/ui/YookassaStepInit';
import { RobokassaStepInit } from '../components/robokassa/ui/RobokassaStepInit';
import { RobokassaStepConnect } from '../components/robokassa/ui/RobokassaStepConnect';
import { CloudpaymentsStepInit } from '../components/cloudPayments/ui/CloudpaymentsStepInit';
import { CloudpaymentsStepConnect } from '../components/cloudPayments/ui/CloudpaymentsStepConnect';
import { UnitpatStepAccess } from '../components/unitpay/ui/UnitpatStepAccess';

export const PAYMENT_SYSTEM = {
    UNITPAY: 'unitpay',
    YOOKASSA: 'yookassa',
    ROBOKASSA: 'robokassa',
    CLOUDPAYMENTS: 'cloudPayments',
} as const;

export const AVAILABLE_SYSTEMS: AvailableSystemsProps[] = [
    {
        position: 0,
        name: PAYMENT_SYSTEM.UNITPAY,
        steps: [UnitpayStepInit, UnitpayStepConnect, UnitpatStepAccess],
    },
    {
        position: 10,
        name: PAYMENT_SYSTEM.YOOKASSA,
        steps: [YookassaStepInit, YookassaStepConnect],
    },
    {
        position: 20,
        name: PAYMENT_SYSTEM.ROBOKASSA,
        steps: [RobokassaStepInit, RobokassaStepConnect],
    },
    {
        position: 30,
        name: PAYMENT_SYSTEM.CLOUDPAYMENTS,
        steps: [CloudpaymentsStepInit, CloudpaymentsStepConnect],
    },
];

export const FORM_WIDTH = 640;

export const formikCommonOptions = {
    validateOnBlur: false,
    validateOnChange: false,
    enableReinitialize: true,
};
